import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  ANALYTICS_CONSENT_DENIED,
  ANALYTICS_CONSENT_GRANTED,
  getAnalyticsConsent,
  initializeAnalytics,
  setAnalyticsConsent,
  trackPageView,
} from '../analytics';
import './AnalyticsConsent.css';

const AnalyticsConsent = () => {
  const location = useLocation();
  const [consent, setConsent] = useState(() => getAnalyticsConsent());
  const [isPreferencesOpen, setIsPreferencesOpen] = useState(false);

  useEffect(() => {
    const openPreferences = () => setIsPreferencesOpen(true);
    const syncConsent = (event) => setConsent(event.detail || getAnalyticsConsent());

    window.addEventListener('analytics-preferences:open', openPreferences);
    window.addEventListener('analytics-consent-changed', syncConsent);

    return () => {
      window.removeEventListener('analytics-preferences:open', openPreferences);
      window.removeEventListener('analytics-consent-changed', syncConsent);
    };
  }, []);

  const saveConsent = (value) => {
    setAnalyticsConsent(value);
    setConsent(value);
    setIsPreferencesOpen(false);

    if (value === ANALYTICS_CONSENT_GRANTED) {
      initializeAnalytics();
      trackPageView(location.pathname, location.search);
    }
  };

  if (consent && !isPreferencesOpen) {
    return null;
  }

  return (
    <div className="analytics-consent" role="dialog" aria-modal="false" aria-labelledby="analytics-consent-title">
      <div className="analytics-consent__content">
        <h2 id="analytics-consent-title">Website analytics</h2>
        <p>
          We use Google Analytics and Microsoft Clarity to understand website visits and improve this site.
          These tools load only if you allow them.
        </p>
        {consent && (
          <p className="analytics-consent__status">
            Analytics are currently {consent === ANALYTICS_CONSENT_GRANTED ? 'enabled' : 'disabled'}.
          </p>
        )}
      </div>
      <div className="analytics-consent__actions">
        <button type="button" className="analytics-consent__secondary" onClick={() => saveConsent(ANALYTICS_CONSENT_DENIED)}>
          Decline
        </button>
        <button type="button" className="analytics-consent__primary" onClick={() => saveConsent(ANALYTICS_CONSENT_GRANTED)}>
          Allow analytics
        </button>
      </div>
    </div>
  );
};

export default AnalyticsConsent;
